import React, { useState, useCallback, useEffect, useRef } from "react";
import Cropper from "react-easy-crop";
import { Slider, Box, Typography } from "@mui/material";
import { getCroppedImg } from "../utils/cropImage";
import { useContext } from "react";
import { DeviceContext } from "../context/DeviceContext";

const ImageCropper = ({
  imageSrc,
  onCropComplete,
  aspect,
  cropShape,
  crop,
  zoom,
  onCropChange,
  onZoomChange,
  cropAreaHeight,
  fillCropArea,
}) => {
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const containerRef = useRef(null);

  const { isMobile } = useContext(DeviceContext);

  useEffect(() => {
    if (!fillCropArea || !containerRef.current) return;
    const ro = new ResizeObserver(([entry]) => {
      setContainerWidth(entry.contentRect.width);
    });
    ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, [fillCropArea]);

  const onCropCompleteHandler = useCallback(
    (croppedArea, croppedAreaPixels) => {
      setCroppedAreaPixels(croppedAreaPixels);
      getCroppedImg(imageSrc, croppedAreaPixels)
        .then(onCropComplete)
        .catch((error) => {
          console.error("Error cropping image:", error);
        });
    },
    [imageSrc, onCropComplete]
  );

  const defaultHeight = isMobile ? "12rem" : "20rem";
  const resolvedHeight = cropAreaHeight ?? defaultHeight;

  const cropSize =
    fillCropArea && containerWidth > 0
      ? { width: containerWidth, height: resolvedHeight }
      : undefined;

  return (
    <Box>
      <Box
        ref={fillCropArea ? containerRef : undefined}
        sx={{
          position: "relative",
          width: "100%",
          height: resolvedHeight,
        }}>
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          cropShape={cropShape}
          aspect={aspect}
          cropSize={cropSize}
          showGrid={!fillCropArea}
          onCropChange={onCropChange}
          onZoomChange={onZoomChange}
          onCropComplete={onCropCompleteHandler}
        />
      </Box>
      <Box sx={{ mt: 2.5, px: isMobile ? 2.5 : 3 }}>
        <Typography variant="body2" sx={{ mb: 1, color: "text.secondary" }}>
          Zoom
        </Typography>
        <Slider
          value={zoom}
          min={1}
          max={3}
          step={0.1}
          aria-labelledby="zoom-slider"
          onChange={(e, newZoom) => onZoomChange(newZoom)}
          sx={{
            px: isMobile ? 1 : 1.5,
          }}
        />
      </Box>
    </Box>
  );
};

export default ImageCropper;
